import { GtmEventType } from '@gn-audio/jss-core';

import { HearingTestEventAction, HearingTestTrackingPayload } from '../types/TrackingTypes';

export const createHearingTestEvent = (
  action: HearingTestEventAction | string,
  label: string | number
): HearingTestTrackingPayload => ({
  event: 'OHT-Interaction' as GtmEventType,
  eventCategory: 'OHT',
  eventAction: action,
  eventLabel: String(label),
});
